/* ================================================================
   BLNK STMNT — Custom Photo Upload Widget
   bs-uploader.js

   SETUP (one-time, 5 min):
   1. Create a FREE Cloudinary account at cloudinary.com
   2. From your dashboard, copy your "Cloud Name"
   3. Go to Settings → Upload → Add upload preset
      - Name it: blanket_uploads
      - Mode: Unsigned
      - Save
   4. Replace YOUR_CLOUD_NAME below with your actual cloud name
   ================================================================ */

(function () {
  'use strict';

  /* ── CONFIG ─────────────────────────────────────────────────── */
  const CFG = {
    cloudName:    'dtn1vpptu',          // Cloudinary cloud name
    uploadPreset: 'blanket_uploads',    // ← your unsigned upload preset name
    maxFileMB:    25,
  };

  /* ── SIZE → ASPECT RATIO MAP ────────────────────────────────── */
  /* Keys must match your Shopify variant option values EXACTLY    */
  const SIZES = {
    'Mini Throw':       { w: 54, h: 40, label: '54"×40"',  rec: '2700×2000 px' },
    'Couch Throw':      { w: 54, h: 54, label: '54"×54"',  rec: '2700×2700 px' },
    'Classic Throw':    { w: 62, h: 54, label: '62"×54"',  rec: '3100×2700 px' },
    'Oversized Throw':  { w: 62, h: 62, label: '62"×62"',  rec: '3100×3100 px' },
    'Full Throw':       { w: 72, h: 54, label: '72"×54"',  rec: '3600×2700 px' },
    'Queen Blanket':    { w: 84, h: 62, label: '84"×62"',  rec: '4200×3100 px' },
  };

  /* ── STATE ───────────────────────────────────────────────────── */
  let currentSize = null;   // e.g. 'Classic Throw'
  let photoURL    = null;   // Cloudinary URL after upload
  let photoBlob   = null;   // raw File object before upload
  let cropState   = { x: 0, y: 0, scale: 1, dragging: false, startX: 0, startY: 0 };

  /* ── INJECT STYLES ───────────────────────────────────────────── */
  function injectStyles() {
    if (document.getElementById('bs-uploader-styles')) return;
    const s = document.createElement('style');
    s.id = 'bs-uploader-styles';
    s.textContent = `
      #bs-uploader {
        margin: 24px 0;
        font-family: 'Inter', sans-serif;
        font-size: 0.9rem;
        color: #1a1810;
      }
      #bs-uploader .bsu-label {
        font-family: 'Syne', sans-serif;
        font-weight: 700;
        font-size: 0.78rem;
        letter-spacing: 0.1em;
        text-transform: uppercase;
        color: #3d4a1e;
        margin-bottom: 10px;
      }
      /* ─ Locked state ─ */
      #bs-uploader .bsu-locked {
        border: 1.5px dashed rgba(90,104,48,0.35);
        padding: 24px;
        display: flex;
        align-items: center;
        gap: 12px;
        color: #7a7060;
        font-size: 0.84rem;
        background: rgba(90,104,48,0.04);
      }
      #bs-uploader .bsu-lock-icon {
        font-size: 1.4rem;
        flex-shrink: 0;
      }
      /* ─ Drop zone ─ */
      #bs-uploader .bsu-dropzone {
        border: 1.5px dashed rgba(90,104,48,0.5);
        padding: 32px 20px;
        text-align: center;
        cursor: pointer;
        background: rgba(90,104,48,0.03);
        transition: border-color 0.2s, background 0.2s;
      }
      #bs-uploader .bsu-dropzone:hover,
      #bs-uploader .bsu-dropzone.drag-over {
        border-color: #5a6830;
        background: rgba(90,104,48,0.07);
      }
      #bs-uploader .bsu-dropzone-icon { font-size: 2rem; margin-bottom: 8px; }
      #bs-uploader .bsu-dropzone p { margin: 0; line-height: 1.6; }
      #bs-uploader .bsu-dropzone strong { color: #5a6830; }
      #bs-uploader .bsu-size-hint {
        font-size: 0.75rem;
        color: #7a7060;
        margin-top: 6px;
      }
      /* ─ Cropper ─ */
      #bs-uploader .bsu-cropper-wrap {
        position: relative;
        width: 100%;
        max-width: 480px;
        margin: 0 auto;
      }
      #bs-uploader .bsu-crop-viewport {
        position: relative;
        width: 100%;
        overflow: hidden;
        background: #111;
        cursor: grab;
        user-select: none;
        touch-action: none;
      }
      #bs-uploader .bsu-crop-viewport:active { cursor: grabbing; }
      #bs-uploader .bsu-crop-img {
        position: absolute;
        transform-origin: 0 0;
        pointer-events: none;
        will-change: transform;
      }
      #bs-uploader .bsu-crop-overlay {
        position: absolute;
        inset: 0;
        pointer-events: none;
      }
      #bs-uploader .bsu-crop-hint {
        font-size: 0.75rem;
        color: #7a7060;
        text-align: center;
        margin-top: 6px;
      }
      #bs-uploader .bsu-zoom-row {
        display: flex;
        align-items: center;
        gap: 10px;
        margin: 10px 0;
        font-size: 0.78rem;
        color: #7a7060;
      }
      #bs-uploader .bsu-zoom-row input[type=range] {
        flex: 1;
        accent-color: #5a6830;
        height: 3px;
      }
      /* ─ Buttons ─ */
      #bs-uploader .bsu-btn-row {
        display: flex;
        gap: 10px;
        margin-top: 14px;
      }
      #bs-uploader .bsu-btn {
        flex: 1;
        padding: 11px 16px;
        font-family: 'Syne', sans-serif;
        font-weight: 700;
        font-size: 0.8rem;
        letter-spacing: 0.07em;
        text-transform: uppercase;
        border: none;
        cursor: pointer;
        transition: background 0.2s, transform 0.15s;
      }
      #bs-uploader .bsu-btn:hover { transform: translateY(-1px); }
      #bs-uploader .bsu-btn-primary { background: #5a6830; color: #f0ebe0; }
      #bs-uploader .bsu-btn-primary:hover { background: #3d4a1e; }
      #bs-uploader .bsu-btn-secondary { background: transparent; border: 1.5px solid #1a1810; color: #1a1810; }
      #bs-uploader .bsu-btn-secondary:hover { background: #1a1810; color: #f0ebe0; }
      /* ─ Preview ─ */
      #bs-uploader .bsu-preview {
        display: flex;
        align-items: center;
        gap: 14px;
        border: 1px solid rgba(90,104,48,0.25);
        padding: 12px 14px;
        background: rgba(90,104,48,0.04);
      }
      #bs-uploader .bsu-preview img {
        width: 72px;
        height: 72px;
        object-fit: cover;
        border: 1px solid rgba(90,104,48,0.2);
        flex-shrink: 0;
      }
      #bs-uploader .bsu-preview-info { flex: 1; }
      #bs-uploader .bsu-preview-info strong {
        display: block;
        font-size: 0.85rem;
        font-weight: 600;
        color: #3d4a1e;
      }
      #bs-uploader .bsu-preview-info span {
        font-size: 0.75rem;
        color: #7a7060;
      }
      #bs-uploader .bsu-change-btn {
        font-size: 0.75rem;
        color: #5a6830;
        background: none;
        border: none;
        cursor: pointer;
        padding: 0;
        text-decoration: underline;
        font-family: inherit;
      }
      /* ─ Progress ─ */
      #bs-uploader .bsu-progress {
        background: rgba(90,104,48,0.1);
        height: 3px;
        margin-top: 10px;
        overflow: hidden;
        border-radius: 99px;
      }
      #bs-uploader .bsu-progress-fill {
        height: 100%;
        background: linear-gradient(90deg, #c4d47a, #5a6830);
        width: 0%;
        transition: width 0.3s ease;
        border-radius: 99px;
      }
      #bs-uploader .bsu-status {
        font-size: 0.78rem;
        color: #5a6830;
        margin-top: 6px;
        font-weight: 500;
      }
      #bs-uploader .bsu-error {
        font-size: 0.8rem;
        color: #b94040;
        margin-top: 8px;
        padding: 8px 12px;
        background: rgba(185,64,64,0.08);
        border-left: 2px solid #b94040;
      }
    `;
    document.head.appendChild(s);
  }

  /* ── BUILD WIDGET HTML ───────────────────────────────────────── */
  function buildWidget() {
    const wrap = document.createElement('div');
    wrap.id = 'bs-uploader';
    wrap.innerHTML = `
      <div class="bsu-label">Your Photo</div>
      <div class="bsu-locked" id="bsu-locked">
        <span class="bsu-lock-icon">🔒</span>
        <span>Select a blanket size above to upload your photo</span>
      </div>
      <div id="bsu-active" style="display:none">
        <div class="bsu-dropzone" id="bsu-dropzone">
          <div class="bsu-dropzone-icon">📸</div>
          <p><strong>Drop your photo here</strong> or tap to browse</p>
          <p class="bsu-size-hint" id="bsu-size-hint">Select a size first</p>
        </div>
        <input type="file" id="bsu-file-input" accept="image/*" style="display:none">
      </div>
      <div id="bsu-cropper" style="display:none">
        <div class="bsu-cropper-wrap">
          <div class="bsu-crop-viewport" id="bsu-crop-viewport">
            <img class="bsu-crop-img" id="bsu-crop-img" draggable="false" alt="">
            <canvas class="bsu-crop-overlay" id="bsu-crop-overlay"></canvas>
          </div>
          <p class="bsu-crop-hint">Drag to reposition · pinch or use slider to zoom</p>
          <div class="bsu-zoom-row">
            <span>🔍</span>
            <input type="range" id="bsu-zoom" min="50" max="300" value="100">
            <span>+</span>
          </div>
        </div>
        <div class="bsu-btn-row">
          <button class="bsu-btn bsu-btn-secondary" id="bsu-cancel-crop">Change Photo</button>
          <button class="bsu-btn bsu-btn-primary"   id="bsu-confirm-crop">Use This Photo</button>
        </div>
        <div id="bsu-error" class="bsu-error" style="display:none"></div>
      </div>
      <div id="bsu-preview" style="display:none">
        <div class="bsu-preview">
          <img id="bsu-thumb" alt="Your blanket photo">
          <div class="bsu-preview-info">
            <strong>✓ Photo saved</strong>
            <span id="bsu-preview-size"></span>
          </div>
          <button class="bsu-change-btn" id="bsu-change-photo">Change</button>
        </div>
        <div class="bsu-progress" id="bsu-progress-bar" style="display:none">
          <div class="bsu-progress-fill" id="bsu-progress-fill"></div>
        </div>
        <div class="bsu-status" id="bsu-status"></div>
      </div>
      <input type="hidden" id="bsu-property-url"  name="properties[Custom Photo URL]" value="">
      <input type="hidden" id="bsu-property-size" name="properties[Blanket Size]"     value="">
    `;
    return wrap;
  }

  /* ── FIND INSERTION POINT ────────────────────────────────────── */
  function insertWidget() {
    const atcBtn = document.querySelector(
      '.product-form__submit, button[name="add"], .product-form__buttons'
    );
    if (!atcBtn || document.getElementById('bs-uploader')) return;

    const form = atcBtn.closest('form') || atcBtn.parentElement;
    const widget = buildWidget();
    form.insertBefore(widget, atcBtn.parentElement || atcBtn);
    bindEvents();
  }

  /* ── BIND ALL EVENTS ─────────────────────────────────────────── */
  function bindEvents() {
    // Variant change → unlock upload
    document.addEventListener('change', onVariantChange);
    // Also watch Shopify's variant change event
    document.addEventListener('variant:changed',   onVariantChanged);
    document.addEventListener('variant:selection', onVariantChanged);

    // Drop zone
    const dropzone  = document.getElementById('bsu-dropzone');
    const fileInput = document.getElementById('bsu-file-input');

    dropzone.addEventListener('click',     () => fileInput.click());
    dropzone.addEventListener('dragover',  e  => { e.preventDefault(); dropzone.classList.add('drag-over'); });
    dropzone.addEventListener('dragleave', () => dropzone.classList.remove('drag-over'));
    dropzone.addEventListener('drop', e => {
      e.preventDefault();
      dropzone.classList.remove('drag-over');
      const file = e.dataTransfer.files[0];
      if (file) handleFile(file);
    });
    fileInput.addEventListener('change', e => {
      if (e.target.files[0]) handleFile(e.target.files[0]);
    });

    // Cropper controls
    document.getElementById('bsu-cancel-crop').addEventListener('click',  resetToDropzone);
    document.getElementById('bsu-confirm-crop').addEventListener('click', confirmCrop);
    document.getElementById('bsu-change-photo').addEventListener('click', resetToDropzone);
    document.getElementById('bsu-zoom').addEventListener('input',   onZoom);

    // Dragging
    const vp = document.getElementById('bsu-crop-viewport');
    vp.addEventListener('mousedown',  startDrag);
    vp.addEventListener('mousemove',  doDrag);
    vp.addEventListener('mouseup',    endDrag);
    vp.addEventListener('mouseleave', endDrag);
    vp.addEventListener('touchstart', startDragTouch, { passive: false });
    vp.addEventListener('touchmove',  doDragTouch,    { passive: false });
    vp.addEventListener('touchend',   endDrag);

    // Check if variant already selected on load
    checkCurrentVariant();
  }

  /* ── VARIANT DETECTION ───────────────────────────────────────── */
  function onVariantChange(e) {
    const el = e.target;
    if (!el.matches('select[name*="Size"], input[name*="Size"], select.product-form__input, input.product-form__radio')) return;
    const val = el.value || el.dataset.value;
    if (val && SIZES[val]) activateForSize(val);
  }

  function onVariantChanged(e) {
    const variant = e.detail?.variant || e.detail;
    if (!variant) return;
    const optKeys = Object.keys(variant).filter(k => k.startsWith('option'));
    for (const key of optKeys) {
      const val = variant[key];
      if (val && SIZES[val]) { activateForSize(val); return; }
    }
  }

  function checkCurrentVariant() {
    // Try reading selected variant from the page
    const sel = document.querySelector('select[name*="Size"], select.product-form__input');
    if (sel && SIZES[sel.value]) { activateForSize(sel.value); return; }

    const radios = document.querySelectorAll('input[type=radio]:checked');
    for (const r of radios) {
      if (SIZES[r.value]) { activateForSize(r.value); return; }
    }

    // Try Shopify's ShopifyAnalytics or meta
    try {
      const meta = document.querySelector('[data-product-json], script[type="application/json"][data-variant]');
      if (meta) {
        const data = JSON.parse(meta.textContent);
        const v    = data.selected_variant || data;
        [v.option1, v.option2, v.option3].forEach(o => { if (o && SIZES[o]) activateForSize(o); });
      }
    } catch (_) {}
  }

  /* ── ACTIVATE UPLOAD FOR A SIZE ──────────────────────────────── */
  function activateForSize(sizeName) {
    currentSize = sizeName;
    const size  = SIZES[sizeName];
    const ratio = size.w / size.h;

    document.getElementById('bsu-locked').style.display = 'none';
    document.getElementById('bsu-active').style.display = 'block';
    document.getElementById('bsu-size-hint').textContent =
      `${sizeName} · ${size.label} · Recommended: ${size.rec}`;
    document.getElementById('bsu-property-size').value = sizeName;

    // Update viewport aspect ratio
    const vp = document.getElementById('bsu-crop-viewport');
    vp.style.paddingBottom = `${(1 / ratio) * 100}%`;
    vp.style.height = '0';
  }

  /* ── FILE HANDLING ───────────────────────────────────────────── */
  function handleFile(file) {
    if (!file.type.startsWith('image/')) {
      showError('Please upload an image file (JPG, PNG, HEIC, etc.)'); return;
    }
    if (file.size > CFG.maxFileMB * 1024 * 1024) {
      showError(`File is too large. Max ${CFG.maxFileMB}MB.`); return;
    }

    photoBlob = file;
    const reader = new FileReader();
    reader.onload = e => showCropper(e.target.result);
    reader.readAsDataURL(file);
  }

  /* ── CROPPER ─────────────────────────────────────────────────── */
  function showCropper(dataURL) {
    document.getElementById('bsu-active').style.display   = 'none';
    document.getElementById('bsu-cropper').style.display  = 'block';
    document.getElementById('bsu-preview').style.display  = 'none';
    document.getElementById('bsu-error').style.display    = 'none';

    const img = document.getElementById('bsu-crop-img');
    img.src   = dataURL;
    img.onload = () => {
      cropState = { x: 0, y: 0, scale: 1, dragging: false, startX: 0, startY: 0 };
      document.getElementById('bsu-zoom').value = 100;
      fitImageToViewport();
      drawOverlay();
    };
  }

  function fitImageToViewport() {
    const vp  = document.getElementById('bsu-crop-viewport');
    const img = document.getElementById('bsu-crop-img');
    const vpW = vp.clientWidth;
    const vpH = vp.clientHeight || vp.offsetHeight || (vpW / (SIZES[currentSize].w / SIZES[currentSize].h));

    const imgNatW = img.naturalWidth;
    const imgNatH = img.naturalHeight;

    // Scale so image fills the viewport (cover)
    const scale = Math.max(vpW / imgNatW, vpH / imgNatH);
    cropState.scale = scale;

    // Center
    cropState.x = (vpW - imgNatW * scale) / 2;
    cropState.y = (vpH - imgNatH * scale) / 2;

    applyTransform();
  }

  function applyTransform() {
    const img = document.getElementById('bsu-crop-img');
    img.style.transform = `translate(${cropState.x}px, ${cropState.y}px) scale(${cropState.scale})`;
  }

  function drawOverlay() {
    const canvas = document.getElementById('bsu-crop-overlay');
    const vp     = document.getElementById('bsu-crop-viewport');
    canvas.width  = vp.clientWidth;
    canvas.height = vp.clientHeight || canvas.width / (SIZES[currentSize].w / SIZES[currentSize].h);

    const ctx = canvas.getContext('2d');
    // Dark overlay
    ctx.fillStyle = 'rgba(0,0,0,0.45)';
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    // Clear the crop window (full viewport = crop window in this design)
    const pad = 0; // no padding — full viewport IS the crop
    ctx.clearRect(pad, pad, canvas.width - pad * 2, canvas.height - pad * 2);

    // Border
    ctx.strokeStyle = '#c4d47a';
    ctx.lineWidth   = 2;
    ctx.strokeRect(pad + 1, pad + 1, canvas.width - pad * 2 - 2, canvas.height - pad * 2 - 2);

    // Corner marks
    const c = 16;
    ctx.strokeStyle = '#c4d47a';
    ctx.lineWidth   = 3;
    [[pad,pad],[canvas.width-pad,pad],[pad,canvas.height-pad],[canvas.width-pad,canvas.height-pad]]
      .forEach(([cx, cy]) => {
        const sx = cx === pad ? 1 : -1;
        const sy = cy === pad ? 1 : -1;
        ctx.beginPath();
        ctx.moveTo(cx + sx * c, cy); ctx.lineTo(cx, cy); ctx.lineTo(cx, cy + sy * c);
        ctx.stroke();
      });
  }

  /* ── DRAG ────────────────────────────────────────────────────── */
  function startDrag(e) {
    cropState.dragging = true;
    cropState.startX   = e.clientX - cropState.x;
    cropState.startY   = e.clientY - cropState.y;
  }
  function doDrag(e) {
    if (!cropState.dragging) return;
    cropState.x = e.clientX - cropState.startX;
    cropState.y = e.clientY - cropState.startY;
    applyTransform();
  }
  function endDrag()  { cropState.dragging = false; }

  function startDragTouch(e) {
    e.preventDefault();
    const t = e.touches[0];
    cropState.dragging = true;
    cropState.startX   = t.clientX - cropState.x;
    cropState.startY   = t.clientY - cropState.y;
  }
  function doDragTouch(e) {
    e.preventDefault();
    if (!cropState.dragging) return;
    const t = e.touches[0];
    cropState.x = t.clientX - cropState.startX;
    cropState.y = t.clientY - cropState.startY;
    applyTransform();
  }

  /* ── ZOOM ────────────────────────────────────────────────────── */
  function onZoom(e) {
    const vp    = document.getElementById('bsu-crop-viewport');
    const vpW   = vp.clientWidth;
    const vpH   = vp.clientHeight || (vpW / (SIZES[currentSize].w / SIZES[currentSize].h));
    const img   = document.getElementById('bsu-crop-img');
    const pct   = parseInt(e.target.value) / 100;
    const baseScale = Math.max(vpW / img.naturalWidth, vpH / img.naturalHeight);
    const newScale  = baseScale * pct;

    // Scale around center
    const cx      = vpW / 2;
    const cy      = vpH / 2;
    const ratio   = newScale / cropState.scale;
    cropState.x   = cx + (cropState.x - cx) * ratio;
    cropState.y   = cy + (cropState.y - cy) * ratio;
    cropState.scale = newScale;
    applyTransform();
  }

  /* ── CONFIRM CROP → EXPORT → UPLOAD ─────────────────────────── */
  function confirmCrop() {
    const vp  = document.getElementById('bsu-crop-viewport');
    const img = document.getElementById('bsu-crop-img');

    const vpW = vp.clientWidth;
    const vpH = vp.clientHeight || (vpW / (SIZES[currentSize].w / SIZES[currentSize].h));

    // What part of the NATURAL image maps to the viewport?
    const natW = img.naturalWidth;
    const natH = img.naturalHeight;

    // cropState.x, cropState.y = translated position of top-left of image (at scale)
    // We need to map viewport (0,0) → (vpW,vpH) back to natural image coordinates
    const srcX = (-cropState.x) / cropState.scale;
    const srcY = (-cropState.y) / cropState.scale;
    const srcW = vpW / cropState.scale;
    const srcH = vpH / cropState.scale;

    // Clamp to image bounds
    const cX = Math.max(0, srcX);
    const cY = Math.max(0, srcY);
    const cW = Math.min(srcW, natW - cX);
    const cH = Math.min(srcH, natH - cY);

    // Output at 300dpi equivalent (~2x the display size for quality)
    const outW = Math.round(Math.min(cW, natW));
    const outH = Math.round(cW > 0 ? outW * (cH / cW) : cH);

    const canvas = document.createElement('canvas');
    canvas.width  = outW;
    canvas.height = outH;
    const ctx = canvas.getContext('2d');
    ctx.drawImage(img, cX, cY, cW, cH, 0, 0, outW, outH);

    canvas.toBlob(blob => {
      if (!blob) { showError('Could not process image. Try a different file.'); return; }
      // Show preview immediately
      const localURL = URL.createObjectURL(blob);
      showPreview(localURL, 'Uploading…');
      uploadToCloudinary(blob, localURL);
    }, 'image/jpeg', 0.92);
  }

  /* ── CLOUDINARY UPLOAD ───────────────────────────────────────── */
  async function uploadToCloudinary(blob, localThumb) {
    if (CFG.cloudName === 'YOUR_CLOUD_NAME') {
      // Dev mode: skip upload, just use local blob URL
      photoURL = localThumb;
      document.getElementById('bsu-property-url').value = localThumb;
      showPreview(localThumb, '⚠ Cloudinary not configured — set up in bs-uploader.js');
      return;
    }

    const bar  = document.getElementById('bsu-progress-bar');
    const fill = document.getElementById('bsu-progress-fill');
    const stat = document.getElementById('bsu-status');

    bar.style.display = 'block';
    stat.textContent  = 'Uploading photo…';

    const fd = new FormData();
    fd.append('file',           blob,             'blanket-photo.jpg');
    fd.append('upload_preset',  CFG.uploadPreset);
    fd.append('folder',         'blanket_orders');
    fd.append('tags',           currentSize.toLowerCase().replace(/\s+/g, '-'));

    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open('POST', `https://api.cloudinary.com/v1_1/${CFG.cloudName}/image/upload`);

      xhr.upload.onprogress = e => {
        if (e.lengthComputable) {
          const pct = Math.round((e.loaded / e.total) * 100);
          fill.style.width = pct + '%';
        }
      };

      xhr.onload = () => {
        bar.style.display = 'none';
        if (xhr.status === 200) {
          const data = JSON.parse(xhr.responseText);
          photoURL = data.secure_url;
          document.getElementById('bsu-property-url').value = photoURL;
          showPreview(localThumb, '✓ Photo uploaded successfully');
          stat.textContent = '✓ Saved';
          resolve(data);
        } else {
          let msg = 'Upload failed. ';
          try { msg += JSON.parse(xhr.responseText).error?.message || ''; } catch (_) {}
          showError(msg);
          reject(new Error(msg));
        }
      };

      xhr.onerror = () => {
        showError('Network error during upload. Please try again.');
        reject(new Error('Network error'));
      };

      xhr.send(fd);
    });
  }

  /* ── PREVIEW ─────────────────────────────────────────────────── */
  function showPreview(thumbURL, statusText) {
    document.getElementById('bsu-active').style.display  = 'none';
    document.getElementById('bsu-cropper').style.display = 'none';
    document.getElementById('bsu-preview').style.display = 'block';

    document.getElementById('bsu-thumb').src            = thumbURL;
    document.getElementById('bsu-preview-size').textContent = currentSize
      ? `${currentSize} · ${SIZES[currentSize]?.label}` : '';
    document.getElementById('bsu-status').textContent   = statusText || '';
  }

  function resetToDropzone() {
    photoURL = null;
    photoBlob = null;
    document.getElementById('bsu-file-input').value = '';
    document.getElementById('bsu-property-url').value = '';
    document.getElementById('bsu-active').style.display   = 'block';
    document.getElementById('bsu-cropper').style.display  = 'none';
    document.getElementById('bsu-preview').style.display  = 'none';
    document.getElementById('bsu-error').style.display    = 'none';
    document.getElementById('bsu-progress-bar').style.display = 'none';
  }

  /* ── HELPERS ─────────────────────────────────────────────────── */
  function showError(msg) {
    const el = document.getElementById('bsu-error');
    if (!el) return;
    el.textContent    = msg;
    el.style.display  = 'block';
  }

  /* ── VALIDATE UPLOAD BEFORE CART ADD ─────────────────────────── */
  function guardCartSubmit() {
    const form = document.querySelector('form[action*="/cart/add"]');
    if (!form) return;
    form.addEventListener('submit', e => {
      if (!currentSize) {
        e.preventDefault();
        alert('Please select a blanket size before adding to cart.');
        return;
      }
      if (!photoURL) {
        e.preventDefault();
        alert('Please upload your photo before adding to cart.');
        return;
      }
    });
  }

  /* ── INIT ────────────────────────────────────────────────────── */
  function init() {
    // Only run on product pages
    if (!document.querySelector('form[action*="/cart/add"]')) return;

    injectStyles();
    insertWidget();
    guardCartSubmit();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
